__turbopack_context__.v({
  "className": "inspiration_938c0e69-module__msdQCW__className",
  "variable": "inspiration_938c0e69-module__msdQCW__variable",
});
